<template>
  <div class="eol-container-box">
      <div class="search-all-box">
        <a-form-model
          layout="inline"
          ref="ruleForm"
          :model="form"
        >
          <a-form-model-item prop="username">
            <a-input v-model="form.username" style="width: 130px" class="search-input" placeholder="请输入账号"></a-input>
          </a-form-model-item>
          <a-form-model-item prop="name">
            <a-input v-model="form.name" style="width: 130px" class="search-input" placeholder="请输入姓名"></a-input>
          </a-form-model-item>
          <a-form-model-item prop="mobile">
            <a-input v-model="form.mobile" style="width: 130px" class="search-input" placeholder="请输入手机号"></a-input>
          </a-form-model-item>
          <a-form-model-item prop="class_id">
            <a-select v-model="form.class_id"
              placeholder="请选择班级"
              style="width: 160px"
              class="multiple-select"
              dropdownClassName="multipleDrop"
            >
              <a-select-option value="" >请选择班级</a-select-option>
              <a-select-option
                v-for="(item, index) in classArr"
                :key="index"
                :value="item.id"
                >{{ item.name }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSearch">搜索</a-button>
            <a-button class="reset-btn" @click="resetForm">重置</a-button
            >
          </a-form-model-item>
        </a-form-model>
        <div class="right-option-box">
           <a-button class="option-btn" type="primary" @click="exportData">导出数据</a-button>
        </div>
      </div>

      <div class="table-all-box">
        <a-table :columns="columns" :data-source="tableData" @change="tableOnChange"  rowKey="id" :bordered="false" size="small" :pagination="false">
          
        </a-table>

        <a-pagination class="school-pagination" v-model="page" :total="totalNum"  @change="pageChange" show-less-items />

      </div>


      <!-- 下载进度 -->
      <a-spin :tip="`下载中 ${progress}% ...`" :spinning="loading">
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
      </a-spin>
    
  </div>
</template>
<script>
import { mapActions } from "vuex";
import axios from "axios";
import services from '../../../assets/js/services';
export default {
  name: "activityProgress",
  components: {
  },
  data() {
    return {
      current: 1,
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        username: '',
        name: '',
        class_id: '',
        mobile: '',
      },
      classArr: [],
      columns: [
        // {
        //   title: "账号",
        //   dataIndex: "username",
        // },
        // {
        //   title: "姓名",
        //   dataIndex: "name",
        // },
        // {
        //   title: "手机号",
        //   dataIndex: "mobile",
        // },
        // {
        //   title: "所属实践班级",
        //   dataIndex: "class_name",
        //   width: '110px',
        // },
        // {
        //   // title: "总体完成进度",
        //   title: () => {
        //     return (
        //       <div>总体<br/>完成进度</div>
        //     );
        //   },
        //   dataIndex: "finish_num",
        //   sorter: true,
        //   width: '100px',
        // },
        // {
        //   // title: "任务1：线上自主学习",
        //   title: () => {
        //     return (
        //       <div>任务1：<br/>线上自主学习</div>
        //     );
        //   },
        //   dataIndex: "num1",
        //   sorter: true,
        //   width: '130px',
        // },
        // {
        //   // title: "任务2：虚拟展厅云游",
        //   title: () => {
        //     return (
        //       <div>任务2：<br/>虚拟展厅云游</div>
        //     );
        //   },
        //   dataIndex: "num2",
        //   width: '130px',
        //   sorter: true
        // },
        // {
        //   // title: "任务3：线下基地实践",
        //   title: () => {
        //     return (
        //       <div>任务3：<br/>线下基地实践</div>
        //     );
        //   },
        //   dataIndex: "num3",
        //   width: '130px',
        //   sorter: true
        // },
        // {
        //   // title: "任务4：答“思政小测”",
        //   title: () => {
        //     return (
        //       <div>任务4<br/>答“思政小测”</div>
        //     );
        //   },
        //   dataIndex: "num4",
        //   width: '130px',
        //   sorter: true
        // },
        // {
        //   // title: "任务5：绘“云馆图谱",
        //   title: () => {
        //     return (
        //       <div>任务5：<br/>绘“云馆图谱"</div>
        //     );
        //   },
        //   dataIndex: "num5",
        //   width: '130px',
        //   sorter: true
        // },
        // {
        //   // title: '任务6：传"点位打卡"',
        //   title: () => {
        //     return (
        //       <div>任务6：<br/>传"点位打卡"</div>
        //     );
        //   },
        //   dataIndex: "num6",
        //   width: '130px',
        //   sorter: true
        // },
        // {
        //   // title: '任务7：创"实践微影"',
        //   title: () => {
        //     return (
        //       <div>任务7：<br/>创"实践微影"</div>
        //     );
        //   },
        //   dataIndex: "num7",
        //   width: '130px',
        //   sorter: true
        // },
      ],
      order: '', // 排序字段
      order_by: '', // 正序asc 倒叙desc
      activity_name: '', // 活动名称
      activity_id: '', //当前活动id
      progress: 0,
      loading: false,
    };
  },
  mounted () {
    this.activity_id = this.$route.query.id
    this.getClassList()
    this.getTableList()
  },
  methods: {
    ...mapActions(["getSchoolActivityClasses","getSchoolActivitySummary"]),
    getClassList() {
      this.getSchoolActivityClasses({activity_id: this.activity_id,page:1,size: 100 }).then((res) => {
        if (res.code == "0000" && res.data) {
          this.classArr = res.data.items;
        }
      })
    },
    // 获取班级列表 表格数据
    getTableList() {
      let params = {
        page: this.page,
        size: this.size,
        activity_id: this.activity_id, 
        name: this.form.name,
        username: this.form.username,
        mobile: this.form.mobile,
        class_id: this.form.class_id,
        type: 2,  // 1成绩2进度,
        order: this.order, // 排序字段
        order_by: this.order_by, // 正序asc 倒叙desc
      };
      this.getSchoolActivitySummary(params).then((res) => {
        if (res.code == "0000" && res.data) {
           let newColumns = res.data.header;
          if (newColumns && newColumns.length > 0) {
            const isScore = (key) => ['finish_num', 'num1', 'num2', 'num3', 'num4', 'num5', 'num6', 'num7'].includes(key);
            const getWidth = (key) => ['finish_num'].includes(key) ? '80px' : ['username', 'name', 'mobile', 'class_name'].includes(key) ? '100px' : '130px';
            
            this.columns = newColumns.map(item => {
              const isTask = item.title && item.title.includes('任务');
              if (isTask) {
                const match = item.title.match(/任务(\d+)：(.*)/);
                const taskNum = match ? match[1] : '';
                const taskName = match ? match[2] : item.title;
                return {
                  title: () => {
                    return <div>任务{taskNum}：<br/>{taskName}</div>;
                  },
                  dataIndex: item.dataIndex,
                  width: getWidth(item.dataIndex),
                  sorter: isScore(item.dataIndex)
                };
              }
              return {
                title: item.title,
                dataIndex: item.dataIndex,
                width: getWidth(item.dataIndex),
                sorter: isScore(item.dataIndex)
              };
            });
            this.tableData = res.data.items;
            this.totalNum = res.data.total;
            this.activity_name = res.data.activity_name
          }
        }
      });
    },
    //通过field 的值进行一个判断，然后在进行排序
    tableOnChange(p, f, s){
      this.order_by = 'desc' // 正序asc 倒叙desc
      //第一个排序
      this.order_by = s.order == 'descend' ? 'desc' : s.order ==  'ascend' ? 'asc' : ''
      if (s.field == 'finish_num') {
        this.order = 'finish_num'
      } else if(s.field == 'num1'){
        this.order = 'num1'
      } else if(s.field == 'num2'){
        this.order = 'num2'
      } else if(s.field == 'num3'){
        this.order = 'num3'
      } else if(s.field == 'num4'){
        this.order = 'num4'
      } else if(s.field == 'num5'){
        this.order = 'num5'
      } else if(s.field == 'num6'){
        this.order = 'num6'
      } else if(s.field == 'num7'){
        this.order = 'num7'
      }
      this.onSearch()
    },
    // 导出数据
    exportData(){
      let that = this
      if (that.tableData && that.tableData.length > 0) {
        that.loading = true
        axios({
          url: services.HOST + `/api/school/train/score`,
          params: { 
            activity_id: this.activity_id, 
            name: this.form.name,
            username: this.form.username,
            mobile: this.form.mobile,
            class_id: this.form.class_id,
            type: 2,  // 1成绩2进度,
            order: this.order, // 排序字段
            order_by: this.order_by, // 正序asc 倒叙desc
            act: 'export' // 导出时传入
          },
          method: 'get',
          responseType: 'arraybuffer',
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              that.progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            }
          },
        }).then(res => {
          that.loading = false
          if (res) {
            let newUrl = window.URL.createObjectURL(new Blob([res.data]));
            let type = 'xlsx'
            that.createUrlBlob(newUrl, `${ this.activity_name || ''}实践进度`, type)
          }
        }).catch(err => {
          that.loading = false
          console.log(err)
        })
      } else {
        that.$message.error("暂无可导出的数据")
      }
    },
    // 文件流处理
    createUrlBlob (url, fileName, type) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.setAttribute('download', `${fileName}.${type}`);
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
     // 搜索按钮
    onSearch() {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    // 分页点击事件
    pageChange(val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    // 搜索重置按钮
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.onSearch()
    }
  },
};
</script>

<style lang="less" scoped>

</style>
